import React from "react";
import { Link } from "react-router-dom";
import { HOMEPAGE } from './../../navigation/Constants';

export interface CompleteRegistretionProps {
    isRegistered: boolean;
}

const CompleteRegistretion = () => {

    return (
        <div className="content_sec white wf-section">
            <div className="signup_top_info">
                <div className="signup_pict">
                    <img src="assets/images/success_pict.svg" loading="lazy" alt="" />
                </div>
                <h2 className="signup_title welcome">ברוך הבא</h2>
                <div>כעת נבקש ממך להשלים פרטים חשובים כדי שנוכל לחבר אותך עם חברי קהילה מתאימים לך. בתום שלב זה, תוכל להתחבר לחברי הקהילה</div>
                <Link className="button_full welcome w-button" to={HOMEPAGE}>
                    המשך
                </Link>
            </div>
        </div>
    )
}

export default CompleteRegistretion;